import React from 'react'
import './index.scss'

const MixBlock1 = (props: any) => {
  const { id, config, rowType, clickTo } = props
  let bgColor = config.bgColor
    ? config.bgColor
    : rowType === 'bgBlock'
    ? 'rgba(0,0,0,0.8)'
    : '#fff'
  return (
    <div
      style={
        rowType !== 'bgBlock'
          ? { background: bgColor }
          : {
              backgroundImage: `linear-gradient(${bgColor},${bgColor}), url(${config.imgSrc})`,
            }
      }
      className={`${rowType || 'imageBlock'} lego_rowsBlock1`}
      onClick={() => clickTo('mixedBlock', config.deepLink, config.link, id)}
    >
      {rowType !== 'bgBlock' && (
        <div className="imageContent">
          <img src={config.imgSrc}></img>
        </div>
      )}
      <div className={`blockTextContent ${config.textModel || ''}`}>
        <div className="titleContent">
          <p className="titleLine1">{config.title1}</p>
          {/* {rowType !== 'bgBlock' && ( */}
          <p className="titleLine2">{config.title2}</p>
          {/* )} */}
        </div>
        <div className="checkNow">
          <span>{config.enterText || '马上查看'}</span>
          <span className="icon">{'>'}</span>
        </div>
      </div>
    </div>
  )
}

export default MixBlock1
